import { render, staticRenderFns } from "./AgileWrap.vue?vue&type=template&id=5b3e44b5"
import script from "./AgileWrap.vue?vue&type=script&lang=js"
export * from "./AgileWrap.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports